






import ReportPowerBiContainer from '@/modules/neodash/components/report-powerbi-container/report-powerbi-container.vue';
import Vue from 'vue';
import Component from 'vue-class-component';
import PbiDictWorkspaceId, { PbiWorkspacesEnum } from './pbi-dict-workspace-id';
import { TupleDictionary } from '@/utils/tupleDictionary';
import { Getter } from 'vuex-class';
import { AUTH_GET_CLIENT, AUTH_GET_COUNTRY, AUTH_GET_VEHICLETYPE } from '@/store/modules/authentication/types';
import { Client } from '@/store/modules/authentication/interfaces';
import { CountryEnum, CountryType } from '@/enums/country.enum';
import { ClientEnum } from '@/enums/client.enum';
import { traceLogAccess } from '@/services';
import { ContextEnum } from '@/enums/context.enum';
import { VehicleTypeEnum } from '@/enums/vehicle-type.enum';

@Component({
  name: 'PbiMarketPotentialPage',
  components: { ReportPowerBiContainer }
})

export default class PbiMarketPotentialPage extends Vue {
  @Getter(AUTH_GET_CLIENT)
  public client: Client;

  @Getter(AUTH_GET_COUNTRY)
  public country: CountryType;

  @Getter(AUTH_GET_VEHICLETYPE)
  public idVehicleType: number;

  private pbiDictWorkspaceId = new PbiDictWorkspaceId();
  public dictReports = new TupleDictionary<[ClientEnum, VehicleTypeEnum, CountryType], IPbiContainer>();
  public crrReport: IPbiContainer = { brand: '', workspaceId: '', reportId: '' };

  mounted() {
    this.dictReports.set([ClientEnum.Mitsubishi, VehicleTypeEnum.Car, CountryEnum.Brasil], { brand: 'Mitsubishi', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: 'd1b6ca72-e886-4e56-a772-349000673c95' });

    this.crrReport = this.dictReports.get([this.client.id, this.idVehicleType, this.country]);
    traceLogAccess.logAction(ContextEnum.Report, `${this.crrReport.brand} - Network Simulator After Sales Report`);
  }
} 

